import { Component, OnInit } from '@angular/core';
import {Product} from '../../dto/product';
import {Order} from '../../dto/order';
import {ActivatedRoute} from '@angular/router';
import {BasicOrderFromUrl} from '../../models/basic-order-from-url';
import {TranslateModule, TranslateLoader, TranslateService} from '@ngx-translate/core';
import {OrderService} from '../services/order.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-order-summary-linkpage',
  templateUrl: './order-summary-linkpage.component.html',
  styleUrls: ['./order-summary-linkpage.component.css']
})
export class OrderSummaryLinkpageComponent implements OnInit {
  product: Product|null;
  productLogoUrl: string|null;
  order: Order|null;
  isError: boolean;
  errorMessage: string|null;
  lang: string;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    private orderService: OrderService,
  ) {

    translate.setDefaultLang('en');

  }

  ngOnInit(): void {

    const orderJsonBase64 = this.route.snapshot.queryParamMap.get('o');
    const orderJson = atob(orderJsonBase64);

    const basicOrder = JSON.parse(orderJson) as BasicOrderFromUrl;
    if ( basicOrder == null ) {
      this.isError = true;
      this.errorMessage = 'Invalid data';
      return;
    }

    const order = new Order();
    order.dob = basicOrder.dob;
    order.firstName = basicOrder.fn;
    order.lastName = basicOrder.ln;
    order.city = basicOrder.ci;
    order.countryName = basicOrder.ct?.toUpperCase();
    order.phone = basicOrder.ph;
    order.email = basicOrder.em;
    order.address = basicOrder.adr;
    order.nationality = basicOrder.nt;
    order.productId = basicOrder.pi;
    order.zipCode = basicOrder.pc;

    this.translate.setDefaultLang(basicOrder.lg);

    this.order = order;

    this.orderService.getProductById(basicOrder.pi).subscribe(data => {
      this.product = data;
      this.productLogoUrl = this.product.logoFileName ? environment.apiUrl + this.product.logoFileName : null;
    });


  }

}
